import type { ReactNode } from "react"

import AdminLayoutTemplate from "@/layouts/admin/admin-sidebar-layout"
import type { BreadcrumbItem } from "@/types"

interface AdminLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}

export default function AdminLayout({
  children,
  breadcrumbs,
  ...props
}: AdminLayoutProps) {
  return (
    <AdminLayoutTemplate breadcrumbs={breadcrumbs} {...props}>
      {children}
    </AdminLayoutTemplate>
  )
}
